import { Core as Cachemap } from '@cachemap/core';
import { init as webStorage } from '@cachemap/web-storage';
import { useEnvs } from '@next-box/envs';
import { FeatureFlagProvider } from '@next-box/feature-flags';
import { type ReactNode, useEffect, useState } from 'react';
import { FeatureFlags } from '#enums/featureFlags.ts';
import featureFlags from '#featureFlags.config.json' with { type: 'json' };

export type FeatureFlagProviderWrapper = {
  children: ReactNode;
  envs: Record<string, string | undefined>;
};

export const FeatureFlagProviderWrapper = ({ children, envs }: FeatureFlagProviderWrapper) => {
  const { getEnv } = useEnvs();
  const [envOverride, setEnvOverride] = useState<Record<string, string | undefined>>();

  useEffect(() => {
    const retrieveKeyAndSetEnv = async () => {
      const cachemap = new Cachemap({
        backupStore: webStorage({ storageType: 'local' }),
        name: FeatureFlags.ExoticPinkPtarmigan,
        type: 'auth',
      });

      const userKey = await cachemap.fetch('EXOTIC_PINK_PTARMIGAN_USER_KEY');

      if (userKey === getEnv('NEXT_PUBLIC_EXOTIC_PINK_PTARMIGAN_KEY')) {
        setEnvOverride({ NEXT_PUBLIC_FF_EXOTIC_PINK_PTARMIGAN: 'true' });
      }
    };

    void retrieveKeyAndSetEnv();
    // Only needs to execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FeatureFlagProvider envs={{ ...envs, ...envOverride }} featureFlags={featureFlags}>
      {children}
    </FeatureFlagProvider>
  );
};
